import { ApiError } from '@/api/client'

/**
 * The server's message, where showing it is safe, and a plain one otherwise.
 *
 * Same list and same reasoning as `Login.tsx`: `INVALID_CREDENTIALS` is deliberately vague
 * on the server -- it answers identically for an unknown email, a wrong password and a
 * disabled account -- and no screen may undo that by guessing which one it was.
 * `CONFLICT` -- which registration answers for an address that already has an account -- is
 * the one case where being specific is both safe and necessary: the shopper already knows
 * whether that address is theirs, and "try signing in instead" is the only useful thing to
 * say to somebody who has simply forgotten they registered last month.
 */
const SHOW_SERVER_MESSAGE = new Set([
  'INVALID_CREDENTIALS',
  'ACCOUNT_LOCKED',
  'ACCOUNT_DISABLED',
  'RATE_LIMITED',
  'CONFLICT',
  'VALIDATION_ERROR',
])

export function storefrontAuthMessage(error: unknown): string {
  if (error instanceof ApiError) {
    if (SHOW_SERVER_MESSAGE.has(error.code)) return error.message
    if (error.status >= 500) return 'The shop had a problem. Please try again in a moment.'
    return error.message
  }
  return 'Could not reach the shop. Check your connection and try again.'
}
